(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const syncGroups = () => {
    document.querySelectorAll('.honey-footer-reference__group').forEach((group) => {
      group.open = !mobileQuery.matches;
    });
  };

  const initialize = () => {
    syncGroups();
    mobileQuery.addEventListener('change', syncGroups);

    document.querySelectorAll('.honey-footer-reference__group > summary').forEach((summary) => {
      summary.addEventListener('click', (event) => {
        if (!mobileQuery.matches) event.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
